<template>
  <div>
    <div class="title">
      酒店总览
      <span class="date-filter">
        <a-date-picker
          style="width:140px"
          :disabledDate="disabledStartDate"
          v-model="json.StartDate"
          @change="Init"
          format="YYYY-MM-DD"
          :allowClear="false"
        />
        -
        <a-date-picker
          style="width:140px"
          v-model="json.EndDate"
          :disabledDate="disabledEndDate"
          @change="Init"
          :allowClear="false"
          format="YYYY-MM-DD"
        />
      </span>
    </div>
    <a-row :gutter="20">
      <a-col :span="6">
        <div class="company-info">
          <span class="logo-img">
            <img
              :src="
                versionConfig.ZHIYUN_VERSION
                  ? `/images/${appConfig.logo ? appConfig.logo : 'zy_logo.png'}`
                  : '/images/logo.png'
              "
            />
          </span>
          <div>
            <h3 class="company-name" style="margin-top: 15px;">
              {{ groupInfo.GroupName }}
            </h3>
            <p>集团编码:{{ groupInfo.GroupCode }}</p>
            <!-- <p>到期时间：2019-12-20</p> -->
          </div>
        </div>
      </a-col>
      <a-col :span="18" class="room-info">
        <a-row>
          <a-col :span="6">
            <div class="item">
              <span class="name">门店数</span>
              <span class="number"
                ><img src="../../assets/images/s_icon1.png" />
                {{ groupInfo.SummaryData.CompanyCountData }}</span
              >
            </div>
          </a-col>
          <a-col :span="6">
            <div class="item">
              <span class="name">会员数</span>
              <span class="number number1"
                ><img src="../../assets/images/s_icon2.png" />
                {{ groupInfo.SummaryData.MemberCountData }}</span
              >
            </div>
          </a-col>
          <a-col :span="6">
            <div class="item">
              <span class="name">营业额</span>
              <span class="number number2"
                ><img src="../../assets/images/s_icon3.png" />
                {{ groupInfo.SummaryData.AmountCountData }}</span
              >
            </div>
          </a-col>
          <a-col :span="6">
            <div class="item">
              <span class="name">订单数</span>
              <span class="number number3"
                ><img src="../../assets/images/s_icon4.png" />
                {{ groupInfo.SummaryData.OrderCountData }}</span
              >
            </div>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-divider class="divider" />
    <div class="title">常用功能</div>
    <a-card :bordered="false">
      <a-card-grid
        v-if="$auth('')"
        class="jump"
        @click="jump('CentralRoomOrder')"
      >
        <img src="../../assets/images/menu_icon1.png" /><br />
        房间预订</a-card-grid
      >
      <a-card-grid class="jump" @click="jump('groupOrderManage')">
        <img src="../../assets/images/menu_icon2.png" /><br />
        订单管理</a-card-grid
      >
      <a-card-grid class="jump" @click="jump('ShopManage')">
        <img src="../../assets/images/menu_icon3.png" /><br />
        门店管理</a-card-grid
      >
      <a-card-grid class="jump" @click="jump('groupMember')"
        ><img src="../../assets/images/menu_icon4.png" /><br />
        会员管理</a-card-grid
      >
      <a-card-grid class="jump" @click="jump('GroupClient')"
        ><img src="../../assets/images/menu_icon5.png" /><br />
        客户管理</a-card-grid
      >
      <a-card-grid class="jump" @click="jump('GroupReportCenterIndex')"
        ><img src="../../assets/images/menu_icon6.png" /><br />
        集团报表</a-card-grid
      >
      <a-card-grid class="jump" @click="jump('GroupRoomoreForcast')">
        <img src="../../assets/images/menu_icon7.png" /><br />
        房情预测</a-card-grid
      >
    </a-card>

    <a-divider class="divider" />
    <div class="title">基础统计</div>
    <a-row :gutter="50">
      <!-- <a-col :span="8">
        <ve-line
          :data="chart_line.chartData_amounts"
          :settings="chart_line.chartSettings_amounts"
          :extend="chart_line.extend"
        ></ve-line>
      </a-col> -->
      <a-col :span="12">
        <ve-line
          :data="chart_line.chartData_orders"
          :settings="chart_line.chartSettings_orders"
          :extend="chart_line.extend"
        ></ve-line>
      </a-col>
      <a-col :span="12">
        <ve-line
          :data="chart_line.chartData_occupancyRates"
          :settings="chart_line.chartSettings_occupancyRates"
          :extend="chart_line.extend_occupancyRates"
        ></ve-line>
      </a-col>
    </a-row>
    <a-divider class="divider" />
    <div class="title">其他统计</div>
    <a-row :gutter="50">
      <!-- <a-col :span="16">
        <ve-histogram
          :data="chart_line.chartData_basicCounts"
          :extend="chart_line.extend"
          :settings="chart_line.chartSettings_basicCounts"
        ></ve-histogram>
      </a-col> -->
      <a-col :span="12">
        <ve-line
          :data="chart_line.chartData_amounts"
          :settings="chart_line.chartSettings_amounts"
          :extend="chart_line.extend"
        ></ve-line>
      </a-col>
      <a-col :span="12">
        <h4 class="sort-title">门店销售额排名</h4>
        <ul class="sort-list">
          <li
            v-for="(item, index) in chart_line.companySales"
            :key="index"
            :class="{ top: index < 3 }"
          >
            <i>{{ index + 1 }}</i
            >{{ item.CompanyName }}<span>￥{{ item.CompanySales }}</span>
          </li>
        </ul>
      </a-col>
    </a-row>
    <a-row :gutter="20" style="margin-top:30px;">
      <a-col :span="8">
        <h5 class="sub-title">
          客源统计(订单数)
        </h5>
        <ve-ring
          v-if="chart_ring.chartData_customerSource.rows.length"
          :data="chart_ring.chartData_customerSource"
          :extend="chart_ring.extend"
          :settings="chart_ring.chartSettings"
        ></ve-ring>
        <ve-ring
          :data="noData"
          :extend="nodataExtend"
          :legend-visible="false"
          :settings="chart_ring.chartSettings"
          v-else
        ></ve-ring>
      </a-col>
      <a-col :span="8">
        <h5 class="sub-title">付款类型统计</h5>
        <ve-ring
          v-if="chart_ring.chartData_paymentType.rows.length"
          :data="chart_ring.chartData_paymentType"
          :extend="chart_ring.extend"
          :settings="chart_ring.chartSettings"
        ></ve-ring>
        <ve-ring
          :data="noData"
          :extend="nodataExtend"
          :legend-visible="false"
          :settings="chart_ring.chartSettings"
          v-else
        ></ve-ring>
      </a-col>
      <a-col :span="8">
        <h5 class="sub-title">消费类型统计</h5>
        <ve-ring
          v-if="chart_ring.chartData_consumptionType.rows.length"
          :data="chart_ring.chartData_consumptionType"
          :extend="chart_ring.extend"
          :settings="chart_ring.chartSettings"
        ></ve-ring>
        <ve-ring
          :data="noData"
          :extend="nodataExtend"
          :legend-visible="false"
          :settings="chart_ring.chartSettings"
          v-else
        ></ve-ring>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import Vue from "vue";
// import VCharts from "v-charts";
import VeHistogram from "v-charts/lib/histogram.common";
import VeRing from "v-charts/lib/ring.common";
import VeLine from "v-charts/lib/line.common";
import { jump, cache } from "@/utils/common";
import { mapState } from "vuex";
import moment from "moment";
Vue.component(VeHistogram.name, VeHistogram);
Vue.component(VeRing.name, VeRing);
Vue.component(VeLine.name, VeLine);
// Vue.use(VCharts);
export default {
  components: {},
  data() {
    this.nodataExtend = {
      series: {
        radius: ["22%", "31%"],
        center: ["19%", "40%"],
        color: "#ccc",
        labelLine: {
          normal: {
            show: false
          }
        },
        label: {
          normal: {
            show: true,
            position: "center"
          }
        }
      }
    };
    return {
      versionConfig,
      groupInfo: {
        SummaryData: {}
      },
      chart_line: {
        extend: {
          series: {
            label: {
              show: true,
              position: "top",
              smooth: false
            }
          }
        },
        //营业额
        chartSettings_amounts: {
          labelMap: {
            Value: "营业额"
          }
        },
        chartData_amounts: { columns: ["Date", "Value"], rows: [] },
        //订单数
        chartSettings_orders: {
          labelMap: {
            Value: "订单数"
          }
        },
        chartData_orders: { columns: ["Date", "Value"], rows: [] },
        //出租率
        chartSettings_occupancyRates: {
          labelMap: {
            Value: "出租率"
          },
          axisSite: { left: ["Value"] },
          yAxisType: ["percent"]
        },
        chartData_occupancyRates: { columns: ["Date", "Value"], rows: [] },
        extend_occupancyRates: {
          series: {
            label: {
              show: true,
              formatter: function(params) {
                if (params.seriesIndex == 0) {
                  let str = (params.data[1] * 100).toFixed(2) + "%";
                  return str;
                }
              }
            }
          }
        },
        //基础统计
        chartSettings_basicCounts: {
          labelMap: {
            Value: "月销售额统计"
          }
        },
        chartData_basicCounts: { columns: ["Date", "Value"], rows: [] },
        //门店营业额排名
        companySales: {}
      },
      chart_ring: {
        extend: {
          tooltip: {
            trigger: "item",
            formatter: "{b}"
          },
          legend: {
            orient: "vertical",
            left: "35%",
            top: 70,
            bottom: 20,
            formatter: function(params) {
              const item = params.split(";");
              const name =
                item[0].length > 6
                  ? item[0].slice(0, 6) +
                    "\n" +
                    item[0].slice(6, item[0].length)
                  : item[0];
              return (
                "{white|" +
                name +
                "}" +
                "{num|" +
                item[1] +
                "}" +
                "{num2|" +
                item[2] +
                "}"
              );
            },
            textStyle: {
              rich: {
                white: {
                  width: 78
                },
                num: {
                  width: 72
                },
                num2: {
                  width: 80
                }
              }
            }
          },
          series: {
            radius: ["22%", "31%"],
            center: ["19%", "40%"],
            labelLine: {
              normal: {
                show: false
              }
            },
            label: {
              normal: {
                show: false
              }
            }
          }
        },
        chartSettings: {
          metrics: ["Percentage"],
          dimension: ["Name"]
        },
        chartData_customerSource: { columns: ["Percentage", "Name"], rows: [] },
        chartData_paymentType: { columns: ["Percentage", "Name"], rows: [] },
        chartData_consumptionType: { columns: ["Percentage", "Name"], rows: [] }
      },
      noData: {
        columns: ["Percentage", "Name"],
        rows: [{ Percentage: "100", Name: "暂无数据" }]
      },
      user: null,
      json: {
        StartDate: null,
        EndDate: null
      }
    };
  },
  computed: {
    ...mapState({
      appConfig: state => state.app.appConfig
    })
  },
  created() {
    this.user = cache.get("user");
    this.json = {
      StartDate: moment(this.user.AccountDate).subtract(3, "d"),
      EndDate: moment(this.user.AccountDate)
    };
    this.Init();
  },
  methods: {
    Init() {
      const StartDate = moment(this.json.StartDate).format("YYYY-MM-DD");
      const EndDate = moment(this.json.EndDate).format("YYYY-MM-DD");
      this.$post("GroupHomePage_Info", { StartDate, EndDate }).then(res => {
        this.groupInfo = res.Data;
      });
      this.$post("GroupHomePage_ChartDataInfo", { StartDate, EndDate }).then(
        res => {
          this.chart_line.chartData_amounts.rows =
            res.Data.Amounts.ChartDetailData;
          this.chart_line.chartData_orders.rows =
            res.Data.Orders.ChartDetailData;
          this.chart_line.chartData_occupancyRates.rows =
            res.Data.OccupancyRates.ChartDetailData;
          this.chart_line.chartData_basicCounts.rows =
            res.Data.BasicCounts.ChartDetailData;
          this.chart_line.companySales = res.Data.CompanySales;
        }
      );
      this.$post("GroupHomePage_PieChartDataInfo", { StartDate, EndDate }).then(
        res => {
          this.chart_ring.chartData_customerSource.rows = res.Data.CustomerSource.DetailDatas.map(
            item => {
              item.Name = item.Name + ";" + item.Value + "; " + item.Percentage;
              if (item.Percentage && item.Percentage != "") {
                item.Percentage = item.Percentage.replace("%", "");
              }
              return item;
            }
          );
          this.chart_ring.chartData_paymentType.rows = res.Data.PaymentType.DetailDatas.map(
            item => {
              item.Name = item.Name + ";" + item.Value + ";" + item.Percentage;
              if (item.Percentage && item.Percentage != "") {
                item.Percentage = item.Percentage.replace("%", "");
              }
              return item;
            }
          );
          this.chart_ring.chartData_consumptionType.rows = res.Data.ConsumptionType.DetailDatas.map(
            item => {
              item.Name = item.Name + ";" + item.Value + ";" + item.Percentage;
              if (item.Percentage && item.Percentage != "") {
                item.Percentage = item.Percentage.replace("%", "");
              }
              return item;
            }
          );
        }
      );
    },
    jump(value) {
      jump(value);
    }, //结束时间选择范围
    disabledEndDate(endValue) {
      return (
        (endValue &&
          this.json.StartDate &&
          endValue < this.json.StartDate.endOf("day")) ||
        endValue >
          moment(this.user.AccountDate)
            .subtract(1, "days")
            .endOf("day")
      );
    },
    disabledStartDate(current) {
      return (
        current &&
        current >
          moment(this.user.AccountDate)
            .subtract(1, "d")
            .endOf("day")
      );
    }
  }
};
</script>
<style lang="less" scoped>
//集团首页
.title {
  margin-bottom: 20px;
}
.sub-title {
  font-size: 18px;
  margin-left: 8%;
}
.divider {
  height: 10px;
  background: #f0f2f5;
  margin-left: -24px;
  width: calc(100% + 48px);
}
.company-info {
  display: flex;
  color: #999;
  .company-name {
    font-size: 20px;
    color: #333;
    letter-spacing: 1px;
    margin-bottom: 10px;
  }
  .logo-img {
    width: 100px;
    margin-right: 15px;
    img {
      width: 100%;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
.item {
  position: relative;
  padding: 20px;
  & > span {
    display: block;
  }
  &:after {
    content: "";
    display: block;
    border-right: 1px dashed #ccc;
    position: absolute;
    right: 0;
    top: 10%;
    height: 80%;
  }
  .name {
    display: block;
    text-align: left;
    color: #999;
  }
  .number {
    display: block;
    color: #4c50ae;
    font-size: 26px;
    font-weight: bold;
  }
  .number1 {
    color: #f1f706;
  }
  .number2 {
    color: #f00;
  }
  .number3 {
    color: #3cb500;
  }
}
.action-menu {
  width: 100%;
  tr {
    border-bottom: 1px solid #ddd;
    &:last-child {
      border-bottom: 0;
    }
  }
  td {
    width: 25%;

    border-right: 1px solid #ddd;
    text-align: center;
    padding: 50px;
    font-size: 20px;
    &:last-child {
      border-right: 0;
    }
  }
}
.sort-title {
  text-align: center;
  font-size: 18px;
  margin-bottom: 10px;
}
.sort-list {
  list-style: none;
  & > li {
    font-size: 16px;
    margin-bottom: 10px;
    &:after {
      content: "";
      display: block;
      clear: both;
      overflow: hidden;
    }
    & > span {
      float: right;
    }
    &.top {
      color: #3094ab;
      i {
        background: #3094ab;
      }
    }
  }

  i {
    font-style: normal;
    width: 24px;
    height: 24px;
    display: inline-block;
    border-radius: 100%;
    background: #7d7d7d;
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    color: #fff;
    margin-right: 10px;
  }
}
.jump {
  width: 25%;
  height: 150px;
  line-height: 44px;
  text-align: center;
  font-size: 20px;
  &:hover {
    cursor: pointer;

    // background: green;
  }
}
</style>
